// ResponsiveGestionAchat.jsx → src/gestion-achat/
// Transmet `orderType` / `moduleLabel` / `moduleLabelPlural` aux deux variantes, ce qui
// rend aussi l'onglet « Bon de commande » mobile (GestionBonCommande n'est qu'un wrapper).
import React from "react";
import GestionAchat from "./GestionAchat";
import AchatsMobile from "../mobile/achats/AchatsMobile";
import useIsMobile from "../hooks/useIsMobile";
import { useLocation } from "react-router-dom";

export default function ResponsiveGestionAchat(props) {
  const isMobile = useIsMobile();
  const location = useLocation();
  const hasReplenishmentPrefill = Boolean(
    location.state?.stockReplenishment ||
      location.state?.productionReplenishment
  );

  return isMobile && !hasReplenishmentPrefill ? (
    <AchatsMobile {...props} />
  ) : (
    <GestionAchat {...props} />
  );
}
